export interface RouteEntry {
  /** Next.js-style template path with `[param]` placeholders */
  path: string;
  /** Template path of the parent route, or null for top-level */
  parent: string | null;
}

export interface RouteTable {
  byTemplate: Map<string, RouteEntry>;
}

export function defineRoutes(entries: readonly RouteEntry[]): RouteTable {
  const byTemplate = new Map<string, RouteEntry>();
  for (const e of entries) byTemplate.set(e.path, e);
  return { byTemplate };
}

function substitute(template: string, params: Record<string, string>): string {
  return template.replace(/\[([^\]]+)\]/g, (_, key) => {
    const v = params[key];
    if (v === undefined) {
      throw new Error(`Missing parameter "${key}" for route template "${template}"`);
    }
    return v;
  });
}

/**
 * Resolve the parent path of a route. If `params` is provided,
 * the returned path has its placeholders substituted.
 */
export function resolveParent(
  table: RouteTable,
  template: string,
  params?: Record<string, string>,
): string | null {
  const entry = table.byTemplate.get(template);
  if (!entry) throw new Error(`Unknown route template "${template}"`);
  if (entry.parent === null) return null;
  if (!params) return entry.parent;
  return substitute(entry.parent, params);
}
